@switch (block.data.layout) {
    @case ('overlay') {
        <core-hero-overlay-layout
            [ngStyle]="contentHeroStyles()"
            [block]="block"
            [hasCustomHeadingTypography]="hasCustomHeadingTypography()"
            [hasCustomDescriptionTypography]="hasCustomDescriptionTypography()"></core-hero-overlay-layout>
    }
    @case ('split') {
        <core-hero-split-layout
            [ngStyle]="contentHeroStyles()"
            [block]="block"
            [hasCustomHeadingTypography]="hasCustomHeadingTypography()"
            [hasCustomDescriptionTypography]="hasCustomDescriptionTypography()"></core-hero-split-layout>
    }
}
